// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sQlE","content":"styles_content__2joTT","row":"styles_row__3ai5o","footer":"styles_footer__2G3Ti","phraseLength":"styles_phraseLength__1bZwO"};